import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface FaqItem {
  id: string;
  question: string;
  answer: string;
  sort_order: number;
}

export function useFaqItems(category: string) {
  return useQuery({
    queryKey: ["faq-items", category],
    queryFn: async (): Promise<FaqItem[]> => {
      const { data, error } = await supabase
        .from("faq_items")
        .select("id, question, answer, sort_order")
        .eq("category", category)
        .eq("status", "published")
        .is("deleted_at", null)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data as FaqItem[]) ?? [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
